import React, { FC, ReactNode, ComponentPropsWithoutRef } from 'react';
import * as TooltipPrimitive from '@radix-ui/react-tooltip';
import { Tooltip, TooltipContent, TooltipTrigger, TooltipArrow } from '@app/shared/ui/tooltip';

interface StandardTooltipProps {
  /** Элемент-триггер для tooltip */
  children: ReactNode;
  /** Текст tooltip */
  text: string;
  /** Дополнительные CSS классы для триггера */
  triggerClassName?: string;
  /** Дополнительные CSS классы для arrow */
  arrowClassName?: string;
  /** Дополнительные CSS классы для content */
  contentClassName?: string;
  /** Пропсы для Tooltip Root */
  tooltipProps?: ComponentPropsWithoutRef<typeof TooltipPrimitive.Root>;
  /** Пропсы для TooltipContent */
  contentProps?: Omit<ComponentPropsWithoutRef<typeof TooltipPrimitive.Content>, 'children'>;
  /** Пропсы для TooltipTrigger */
  triggerProps?: ComponentPropsWithoutRef<typeof TooltipPrimitive.Trigger>;
  /** Пропсы для TooltipArrow */
  arrowProps?: ComponentPropsWithoutRef<typeof TooltipPrimitive.Arrow>;
}

export const StandardTooltip: FC<StandardTooltipProps> = ({
  children,
  text,
  triggerClassName,
  arrowClassName,
  contentClassName,
  tooltipProps,
  contentProps,
  triggerProps,
  arrowProps,
}) => {
  return (
    <Tooltip {...tooltipProps}>
      <TooltipTrigger asChild className={triggerClassName} {...triggerProps}>
        {children}
      </TooltipTrigger>
      <TooltipContent className={contentClassName} {...contentProps}>
        <TooltipArrow className={arrowClassName} width={12} height={6} {...arrowProps} />
        <span className="text-font_ds_title_input_12_inputs text-general_text_MII_secondary_i">
          {text}
        </span>
      </TooltipContent>
    </Tooltip>
  );
};
